import {PageManager} from 'genesis-packages/core';
import 'extensions/checkout/checkout.scss';
import 'extensions/proforma/components/x-proforma';
import 'extensions/proforma/components/x-installation-section';
import 'extensions/proforma/components/x-installation-item';
import 'extensions/proforma/components/x-installation-terms';
import Checkout from 'extensions/checkout/Checkout.js';
import ExitTrigger from '@mvps-genesis/exit-trigger';

export default class PROFORMA extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

	onReady () {
		let redirectUrl = this.pageContext.Basket_Url;
		if (this.pageContext.ProForma_Modify_Quote && this.pageContext.ProForma_QuoteCode) {
			redirectUrl = `${this.pageContext.Quote_Url}QuoteCode=${this.pageContext.ProForma_QuoteCode}`;
		}

		new ExitTrigger('.js-exit-trigger', {
			message: 'Are you sure you want to exit checkout?',
			redirectUrl: redirectUrl
		});

		new Checkout();

		if (this.pageContext?.Customer_Permissions?.WebstorePricing) {
			const subtotalElement = document.querySelector('.t-basket__charge-amount');
			const totalElements = document.getElementsByClassName('js-basket-total-element');

			let subtotal = window.mivaJS.Proforma_Basket_Subtotal;

			window.addEventListener('update_total', (e) => {
				let formattedCurrency = new Intl.NumberFormat('en-AU', {
					currency: 'AUD',
					style: 'currency'
				}).format(subtotal + e.detail.total);
				subtotalElement.innerHTML = formattedCurrency;
				for (const totalElement of totalElements) {
					totalElement.innerHTML = formattedCurrency;
				}
			});
		}

	}

}
